export const defaultDisplayWeekDay = '0,1,2,3,4,5,6';
export type DisplayWeekDay = string;
